"use client";

import Image from "next/image";
import Link from "next/link";
import { ArrowUpLeft, CalendarDays } from "lucide-react";
import useGeneralStore from "@/store/General/useGeneralStore";
import { parseJsonBody } from "@/lib/general.utils";
import { EventsJsonBody } from "@/core/models/DashboardComponent.model";
import { useTranslation } from "next-i18next";

const EventsComponent = () => {
  const { EventsComponent } = useGeneralStore();
  const { i18n } = useTranslation();
  const data = parseJsonBody(EventsComponent?.jsonBody) as EventsJsonBody;
  return (
    <section
      dir={i18n.dir()}
      lang={i18n.language}
      className="bg-white py-[3rem] md:py-[5rem] px-[1rem] md:px-[2rem]"
    >
      <div className="max-w-[120rem] mx-auto">
        <h1 className="text-tertiary text-[2rem] sm:text-[2.5rem] md:text-[3rem] lg:text-[4rem] font-bold text-center mb-[1rem]">
          {data.header?.title || EventsComponent?.title}
        </h1>
        <p className="max-w-[55rem] mx-auto text-[#575757] text-[1rem] md:text-[1.2rem] leading-relaxed text-center mb-[3rem]">
          {data.header?.description}
        </p>
        <div className="grid md:grid-cols-3 gap-[1.5rem] md:gap-[2rem]">
          {(data.events || []).map((event) => (
            <article
              key={event.id}
              className="rounded-[1rem] overflow-hidden shadow-lg bg-white flex flex-col h-full"
            >
              <div className="relative aspect-[3/2] shrink-0">
                {event.imgUrl && (
                  <Image
                    src={event.imgUrl}
                    alt={event.title}
                    fill
                    sizes="(max-width: 768px) 100vw, 33vw"
                    className="object-cover"
                  />
                )}
              </div>
              <div className="p-[1.5rem] md:p-[2rem] flex flex-col flex-1">
                <span className="inline-flex items-center gap-2 text-xs text-tertiary mb-4">
                  <CalendarDays size={16} aria-hidden="true" />
                  {event.subtitle}
                </span>
                <h2 className="text-[1.2rem] md:text-[1.5rem] font-bold leading-[1.6] text-tertiary mb-[1rem] md:min-h-[4.8rem]">
                  {event.title}
                </h2>
                <p className="text-[1rem] leading-[1.8] text-[#575757] mb-[1.5rem]">
                  {event.description}
                </p>
                <Link
                  href={event.href || "/volunteer"}
                  className="inline-flex items-center justify-center self-start gap-2 bg-secondary text-white font-bold text-[1rem] rounded-[0.5rem] px-[1.5rem] py-[0.75rem] mt-auto"
                >
                  {event.buttonLabel}{" "}
                  <ArrowUpLeft size={17} aria-hidden="true" />
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
export default EventsComponent;
